import { Button, Modal, ModalBody, ModalFooter, ModalHeader, SkeletonLine, } from '@one-thd/sui-atomic-components';
import React, { useState } from 'react';
import { useCommonContext } from '../../../hooks/useContexts';
import { returnCCImage } from '../../../utils/cc-images';
import { PaymentIconsAndDigits } from '../../shared/PaymentIconAndDigit';
var renderSkeletonLoader = function () {
    return React.createElement(SkeletonLine, { variant: "single", numberOfLines: 1, fullWidth: true });
};
export var TablePayments = function (_a) {
    var _b, _c;
    var orderNumber = _a.orderNumber, tenders = _a.tenders, paymentMethods = _a.paymentMethods, orderDetailsLoaded = _a.orderDetailsLoaded, orderDetailsError = _a.orderDetailsError;
    var isTablet = useCommonContext().isTablet;
    var _d = useState(false), isModalOpen = _d[0], setIsModalOpen = _d[1];
    var modalSize = isTablet ? 'md' : 'sm';
    var orderPaymentMethods = ((_b = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.length) !== null && _b !== void 0 ? _b : 0) > 0 ? paymentMethods : tenders;
    var renderCardTypeLogic = function (type) {
        if (type && returnCCImage(type, 50, 50)) {
            return React.createElement("div", { className: "cardImage" }, returnCCImage(type, 50, 50));
        }
        return null;
    };
    if (orderDetailsError) {
        return null;
    }
    if (!orderDetailsLoaded) {
        return renderSkeletonLoader();
    }
    var filterMatchingAmounts = function (payments) {
        var negativeAmounts = new Map();
        payments === null || payments === void 0 ? void 0 : payments.forEach(function (el) {
            var _a;
            if (((_a = el === null || el === void 0 ? void 0 : el.amount) !== null && _a !== void 0 ? _a : 0) < 0) {
                var key = "".concat(typeof (el === null || el === void 0 ? void 0 : el.amount) === 'number' ? el.amount * -1 : 0, "-").concat('lastFour' in el ? el.lastFour : '');
                negativeAmounts.set(key, true);
            }
        });
        return payments === null || payments === void 0 ? void 0 : payments.filter(function (el) {
            var amount = typeof el.amount === 'number'
                ? el.amount
                : parseFloat(el.amount || '0');
            var lastFour = 'lastFour' in el ? el.lastFour : undefined;
            var key = "".concat(amount, "-").concat(lastFour);
            if (amount > 0 && negativeAmounts.has(key)) {
                negativeAmounts.delete(key); // Remove to handle duplicates
                return false;
            }
            return true;
        });
    };
    var filteredOrderPaymentMethods = filterMatchingAmounts(orderPaymentMethods !== null && orderPaymentMethods !== void 0 ? orderPaymentMethods : []);
    return (React.createElement(React.Fragment, null, ((_c = filteredOrderPaymentMethods === null || filteredOrderPaymentMethods === void 0 ? void 0 : filteredOrderPaymentMethods.length) !== null && _c !== void 0 ? _c : 0) > 1 ? (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: "sui-underline hover:sui-no-underline sui-text-ellipsis sui-text-base", onClick: function () { return setIsModalOpen(true); } }, "Multiple"),
        React.createElement(Modal, { open: isModalOpen, onClose: function () { return setIsModalOpen(false); }, size: modalSize },
            React.createElement(ModalHeader, { onClose: function () { return setIsModalOpen(false); } }, "Payments for Order # ".concat(orderNumber)),
            React.createElement(ModalBody, null,
                React.createElement("div", { className: "sui-pb-1" },
                    "Below are the payment methods (",
                    React.createElement("span", { style: { fontWeight: 'bold' } }, filteredOrderPaymentMethods === null || filteredOrderPaymentMethods === void 0 ? void 0 : filteredOrderPaymentMethods.length),
                    ") used for this order:"),
                React.createElement("table", { className: "sui-table sui-w-full " },
                    React.createElement("thead", { className: "sui-table-header-group" },
                        React.createElement("tr", { className: "sui-table-row sui-border-b-1 sui-border-solid sui-border-primary" },
                            React.createElement("th", null, "Type"),
                            React.createElement("th", null, "Account #"),
                            React.createElement("th", null, "Amount"))),
                    React.createElement("tbody", null, filteredOrderPaymentMethods === null || filteredOrderPaymentMethods === void 0 ? void 0 : filteredOrderPaymentMethods.map(function (el, i) {
                        var _a;
                        return (React.createElement("tr", { key: i, className: "sui-table-row" },
                            React.createElement("td", { align: "center", className: "sui-py-1" }, renderCardTypeLogic(el.cardType ||
                                el.type)),
                            React.createElement("td", { align: "center", className: "sui-py-1" },
                                React.createElement("span", null, "- "),
                                el.lastFour ||
                                    el.value),
                            React.createElement("td", { align: "center", className: "sui-py-1" }, el.amount
                                ? "$".concat((_a = Number(el.amount)) === null || _a === void 0 ? void 0 : _a.toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                }))
                                : '')));
                    })))),
            React.createElement(ModalFooter, { position: "end" },
                React.createElement(Button, { variant: "primary", onClick: function () { return setIsModalOpen(false); } }, "Close"))))) : (React.createElement(PaymentIconsAndDigits, { payments: tenders, paymentMethods: paymentMethods }))));
};
